export const OVERVIEW_MAP_PREDICTION_DAYS_IN_ADVANCE = 1;
// the factor to adjust query time for the safety prediction based on the number of days to query
export const SAFETY_PREDICTION_TIMESTAMP_QUERY_FACTOR = 2;

export const DEFAULT_SAFETY_PREDICTION_PERIOD = 3;

export const DEFAULT_SAFETY_PREDICTION_EXTENDED_PERIOD = 7;
